/**
 * Ajuda dos campos do segurado (P-SEG-1).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6, e docs/ADR/0029-segurado.md.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/segurados': {
    'Razao social ou nome':
      'Razao social do orgao ou da empresa, ou o nome da pessoa fisica. E o nome que a minuta escreve como segurado.',
    'CPF ou CNPJ':
      'O segurado aceita CPF (pessoa fisica) e CNPJ (pessoa juridica), com ou sem pontuacao. O digito verificador e conferido, e o documento nao muda depois do cadastro.',
    Ramo: 'Segurado publico ou privado, o Ramo da lista. A regra de consulta do segurado publico esta pendente.',
    'E-mail do segurado': 'E-mail de contato do segurado. Opcional.',
    'Nome do Segurado': 'Procura na razao social e nos nomes fantasia do segurado.',
    'CNPJ Segurado':
      'Procura pelos digitos do documento, com ou sem pontuacao. Aceita CPF tambem.',
    'Tipo de segurado':
      'Pessoa juridica, pessoa fisica ou junta comercial cadastrada como segurado.',
    'Motivo do bloqueio':
      'Obrigatorio. Fica no cadastro e no historico. O bloqueio ainda nao impede a operacao: o efeito dele nao foi definido pela seguradora.',
    'Ordem do endereco': 'Posicao do endereco na lista do segurado, a partir de zero.',
    'Telefone com DDD':
      'Telefone so com os digitos ou com a mascara, de dez a treze digitos com o DDD. O primeiro telefone vira o principal.',
    'Buscar CNAE':
      'Digite parte do codigo ou da atividade para procurar no catalogo oficial da CNAE. O primeiro CNAE vira o principal.',
    'Novo nome fantasia':
      'Nome fantasia do segurado, que aparece para escolha na cotacao. O primeiro vira o principal.',
    // Socios / Administradores (P-SEG-2).
    'Papel no quadro':
      'Socio, administrador ou representante, os tres blocos da aba. Os papeis do sistema anterior ainda estao a confirmar.',
    'Nome da pessoa':
      'Nome da pessoa fisica ou razao social da empresa que esta no quadro.',
    'CPF/CNPJ da pessoa':
      'CPF ou CNPJ, com ou sem pontuacao. O tipo segue a quantidade de digitos, e o digito verificador e conferido.',
    'Descricao do papel':
      'Cargo ou qualificacao, como Diretor ou Socio administrador. Opcional.',
    'Participacao (%)':
      'Percentual do capital, com ate duas casas decimais (0,01% e o menor valor). Participacao com mais casas nao e arredondada: fica pendente ate a definicao da forma de guardar o valor exato.',
    'Socio de':
      'Pessoa juridica do quadro de quem esta pessoa e socia. Vazio e socio direto do segurado. So pessoa juridica tem socios.',
  },
};
